import { render, staticRenderFns } from "./depositHistoryMobile.vue?vue&type=template&id=6fc46b75"
import script from "./depositHistoryMobile.vue?vue&type=script&lang=js"
export * from "./depositHistoryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports